import {z} from 'zod';

export const DownloadNewFormSchema = z.object({
  dateFrom: z.date(),
});

export type DownloadNewForm = z.infer<typeof DownloadNewFormSchema>;
